import dayjs from "dayjs";
import { Schedule } from "./Schedule";

export class TimeTable {
	public static default = (fallbackMonths: number) => {
		const today = dayjs();
		const maxDate = today.add(fallbackMonths, "months");
		const totalDays = maxDate.diff(today, "days");

		const schedules: Schedule[] = Array.from({ length: totalDays }, (_, i) => {
			const date = today.add(i, "day");
			return { departureDate: date };
		});

		return { outbound: schedules, inbound: schedules };
	};
}
